<template>
  <div class="youtube-video" @click="playVideo">
    <slot v-if="!isPlaying"></slot>
    <div v-if="isPlaying" class="video-container">
      <iframe
        :src="videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="video"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  computed: {
    videoUrl() {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1`;
    },
  },
  methods: {
    playVideo() {
      this.isPlaying = true;
    },
  },
};
</script>

<style scoped>
.youtube-video {
  position: relative;
  cursor: pointer;
}
img {
  width: 100%;
  display: block;
}
.video-container {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
